<template>
  <div class="modal-dialog">
    <div class="modal-content" style="width:600px">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t('sdl.gcrm.breadcrumb.notice.list') }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" >
        개인정보 조회 가능 시스템에 대한 보안 강화에 따라, <br>

한국총괄 GCRM 시스템 (Loyalty Korea) 은 Knox 퀵링크를 통한 접속만 허용될 예정입니다.<br>

아래 변경사항 및 적용 일시 참고하여 주시고, 문의사항이 있으시면 담당자 연락 부탁 드립니다.<br>

<br><br>

□ 변경사항 : 한국총괄 GCRM 시스템 접속 방법 변경
<br>
    - As-is : ①Knox 퀵링크 및 ②GCRM 포털에서 Loyalty Korea 시스템 클릭시 접속 가능
    <br>
    - To-be : ①Knox 퀵링크 로만 접속 가능 (포털에서 Loyalty Korea 링크 히든 예정)

    <br>
    <br>

□ 변경시점 : 3/20 (월) ~
<br>
※ 담당자 : 심미소프로 (miso.sim@samsung.com)

    </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">
          {{ $t('sdl.common.label.close') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { SDLUtil } from '@/utils';

export default {
  data() {
    return {
      htmlDoc: {},
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  methods: {
    loadHtmlDoc() {
        
    },
  },

  created() {
    this.loadHtmlDoc();
  },
  computed: {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/view/admin/main/PopupLoyaltyKorea.vue